import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ButtonAdd } from '@features/events/common';
import { Close } from '@shared/assets';
import { Card, IconButton, ImageInput, ImageInputCropper, Textarea } from '@shared/ui';
import { fieldToUppercase } from 'library/helpers/events';
import * as st from './styles.module.scss';

export const Block = (): JSX.Element => {
  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const {
    fields: blockFields,
    append: appendBlock,
    remove: removeBlock,
  } = useFieldArray({
    name: 'event_block',
    control,
  });

  const blockTitle = blockFields.length > 1 ? 'Универсальные блоки' : 'Универсальный блок';

  return (
    <fieldset className={st.blocks}>
      <h3>{blockTitle}</h3>
      {blockFields.length ? (
        <div className={st.blocks__addSmall}>
          <ButtonAdd
            variant="white"
            handler={() =>
              appendBlock({
                title: '',
                subtitle: '',
                image: '',
                description: '',
              })
            }
            disabled={!!errors.event_block}
          />
        </div>
      ) : (
        <Card
          className={st.blocks__add}
          onClick={() =>
            appendBlock({
              title: '',
              subtitle: '',
              image: '',
              description: '',
            })
          }
        >
          <ButtonAdd variant="dark" disabled={!!errors.event_block} />
          <span>Добавить</span>
        </Card>
      )}
      {blockFields.map((field, index) => (
        <Card key={index} className={st.block}>
          <div className={st.block__info}>
            <div className={st.block__title}>
              <Controller
                name={`event_block.${index}.title` as `event_block.0.title`}
                control={control}
                render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                  <TextField
                    type="text"
                    size="small"
                    label="Заголовок"
                    autoComplete="new-password"
                    error={!!error}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e) => onChange((e.target.value = fieldToUppercase(e)))}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
              <Controller
                name={`event_block.${index}.subtitle` as `event_block.0.subtitle`}
                control={control}
                render={({ field: { onChange, value, onBlur } }) => (
                  <TextField
                    type="text"
                    size="small"
                    label="Подзаголовок"
                    autoComplete="new-password"
                    value={value}
                    onBlur={onBlur}
                    onChange={(e) => onChange((e.target.value = fieldToUppercase(e)))}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </div>
            <div className={st.block__text}>
              <div className={st.block__photo}>
                <Controller
                  control={control}
                  name={`event_block.${index}.image`}
                  render={({ field: { value }, fieldState: { error } }) => (
                    <ImageInputCropper
                      aspect={[16, 9]}
                      value={value}
                      onChange={(value) => {
                        value && setValue(`event_block.${index}.image`, value);
                      }}
                      isValid={!!error}
                    />
                  )}
                />
              </div>
              <div className={st.block__description}>
                <Textarea
                  autosize
                  label="Текст"
                  {...register(`event_block.${index}.description` as `event_block.0.description`, {
                    onChange: (e) => (e.target.value = fieldToUppercase(e)),
                  })}
                  required={!!errors[`event_block.${index}.description`]}
                />
              </div>
            </div>
          </div>
          <div className={st.block__close}>
            <IconButton variant="transparent" onClick={() => removeBlock(index)}>
              <Close />
            </IconButton>
          </div>
        </Card>
      ))}
    </fieldset>
  );
};
